import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { remove as _remove } from 'lodash';
import { concatMap, filter, tap } from 'rxjs/operators';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { PGHOktaService } from 'src/app/core/services/pghokta.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';
import { OktaUserProfile, UserClaims } from 'src/app/model/okta/userClaims';
import { Subscription } from 'rxjs';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CHAT, CHATGROUP } from '../../../core/constants/feature-key.constants';
import { DeviceAutoCompleteMfeService } from 'src/app/shared/device-auto-complete-mfe/device-auto-complete-mfe.service';
import { EssDeviceDto } from 'src/app/shared/device-auto-complete-mfe/ess-device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { DeviceCardDiagnosticTestStatus, DeviceCardTemplate } from 'src/app/shared/device/device-card/device-card.component';
import { IDeviceCardDetails } from 'src/app/shared/device/device-card/device-card.component';
import { AccountService } from 'src/app/core/services/account.service';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { UtilityService } from 'src/app/core/services/utility.service';
import { UpdateDeviceBodyDto } from 'src/app/core/services/device-inventory/update-device-body.dto';
import { DeviceTypeService } from 'src/app/shared/device/device-type/device-type.service';
import { DeviceDetailsDialogData } from 'src/app/modules/home-devices/components/device-details-dialog/device-details-dialog-data';
import { DeviceDetailsDialogComponent } from 'src/app/modules/home-devices/components/device-details-dialog/device-details-dialog.component';
import { ADPResourceService } from 'digital-core';
import { ResumeDiagnosticTestModalComponent } from 'src/app/modules/device-diagnostics/components/resume-diagnostic-test-modal/resume-diagnostic-test-modal.component';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { UserInfoReportingService } from 'src/app/core/services/user-info-refporting.service';
import { GTMDeviceFlow, GTMEvents } from '../../../model/google-tag-manager/api-status';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { StorageService } from 'src/app/core/services/storage.service';
import { CryptoService } from 'src/app/core/services/cypto/crypto.service';

@Component({
  selector: 'pgh-device-inventory',
  templateUrl: './device-inventory.component.html',
  styleUrls: ['./device-inventory.component.scss'],
})
export class DeviceInventoryComponent implements OnInit, OnDestroy {
  @Input() public isSelectDeviceView?: boolean = false;
  @Input() public deviceViewType?: string = undefined;
  @Input() public loadMobileInventoryOnly?: boolean = false;
  @Input() public loadHomeInventoryOnly?: boolean = false;
  //@Output() handleAddAction = new EventEmitter<string>();
  @Output() handleAddSearchDeviceAction = new EventEmitter();

  public accessToken: string = null;
  public hasRegisteredDevices: boolean = true;
  public hasClientSoldPolicy: boolean = false;
  public deviceAutocompleteContentInputs: any = {};
  public isTechServicesChatEnabled: boolean = false;
  public isPhonePlanSupported: boolean = false;
  public programCode: string;
  private selectedContract?: ISelectedContract;
  private phoneInventoryInfo?: InventoryInfoDto;
  private deviceInventoryInfo?: InventoryInfoDto;
  private clientSoldDeviceInventoryInfo?: InventoryInfoDto;
  private phoneDevices?: DeviceDto[] = [];
  private homeDevices?: DeviceDto[] = [];
  private subscriptions: Subscription[] = [];
  private isEprismOnly: boolean;

  // GA variables
  private userEmail: string;
  private userType: string;
  private usersOnContract: number;

  // test temp
  public deviceDetails: IDeviceCardDetails;
  public phoneInventoryList: IDeviceCardDetails[] = [];
  public deviceInventoryList: IDeviceCardDetails[] = [];
  public eprismDeviceInventoryList: IDeviceCardDetails[] = [];
  //public deviceCardTemplate: DeviceCardTemplate = DeviceCardTemplate.home_device;

  public inventoryList: IDeviceCardDetails[] = [];
  public inventoryAllDevicesList: IDeviceCardDetails[] = [];
  public homeDevicesInventoryList: IDeviceCardDetails[] = [];
  public phoneDevicesLoaded: boolean = false;
  public homeDevicesLoaded: boolean = false;

  public sortFormGroup: FormGroup;

  public phonesCount: number = 0;
  public homeCount: number = 0;
  public watchCount: number = 0;
  public tabletCount: number = 0;

  public selectViewTotalCount: number = 0;

  public noDevicesFound: boolean = true;
  public noHomeDevicesFound: boolean = true;
  public noSmartPhoneDevicesFound: boolean = true;
  public noTabletDevicesFound: boolean = true;
  public noSmartWatchDevicesFound: boolean = true;

  public showNoDevicesSection: boolean = true;
  public showNoPhoneDevicesSection: boolean = false;
  public showNoWatchDevicesSection: boolean = false;
  public showNoTabletDevicesSection: boolean = false;
  public showNoHomeDevicesSection: boolean = false;

  public selectedChipValue: string = 'chip1';

  public isSelectViewTemplate: boolean = false;
  private cancelledOrExpiredHasFullAccess: boolean = false;

  public isSPOEEnabled:boolean = false;
  public isMobileSize: boolean = false;
  public hasP360MobilePolicy = false;
  public hasP360HomeTechPolicy = false;

  public isComponentLoaded: boolean = false;

  get isChatDisabled() {
    return (
      (this.selectedContract?.isCancelled ?? false) ||
      ((this.selectedContract?.isExpired ?? false) && !this.cancelledOrExpiredHasFullAccess)
    );
  }

  @ViewChild('chipsList')
  private chipList?: ElementRef<any>;
  private addNewDeviceStr: string = '';

  constructor(
    private router: Router,
    public httpClient: HttpClient,
    private loggedInUserSettings: LoggedInUserSettings,
    private analytics: GoogleAnalyticsService,
    private selectedDeviceService: SelectedDeviceService,
    private deviceInventoryService: DeviceInventoryService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private pghOktaService: PGHOktaService,
    private deviceAutoCompleteMfeService: DeviceAutoCompleteMfeService,
    private accountService: AccountService,
    private deviceTypeService: DeviceTypeService,
    private utilityServce: UtilityService,
    private resourceService: ADPResourceService,
    private userInfoReportingService: UserInfoReportingService,
    private breakpointObserver: BreakpointObserver,
    private storageService: StorageService,
    private cryptoService: CryptoService
  ) {
    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
      this.isMobileSize = result.matches;
    });
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.isMobileSize = window.innerWidth < 992;
  }

  async ngOnInit() {
    this.hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
    this.hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';
    this.isEprismOnly = this.hasP360MobilePolicy && !this.hasP360HomeTechPolicy;
    this.isSelectViewTemplate = this.isSelectDeviceView;
    this.loadComponents();
    this.cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');
    this.isSPOEEnabled = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');
    this.addNewDeviceStr = this.resourceService.getPortaLabelValue("DeviceInventory_SPOE_AddDevice_Label");
  }

  public handleAlphabeticalSortInventoryList() {
    this.inventoryList.sort((a, b) => {
      const aLower = a.title.toLowerCase();
      const bLower = b.title.toLowerCase();
      if (aLower < bLower) return -1;
      if (aLower > bLower) return 1;
      return 0;
    });
  }

  public handleDefaultSortInventoryList() {
    if (this.sortFormGroup.get('sortSelect').value === 0) {
      // sort by Most Relevant
      this.handleRelevantSortInventoryList();
    } else if (this.sortFormGroup.get('sortSelect').value === 1) {
      // sort by Most Recent
      this.handleSortMostRecentInventoryList();
    } else if (this.sortFormGroup.get('sortSelect').value === 2) {
      // sort Alphabetically
      this.handleAlphabeticalSortInventoryList();
    }
  }

  public handleRelevantSortInventoryList() {
    let tempAllInventoryList = this.inventoryAllDevicesList;
    let tempPhoneInventoryList = this.phoneInventoryList;

    if (this.isSelectViewTemplate) {
      tempPhoneInventoryList = this.phoneInventoryList.filter(
        (phoneInventoryList) =>
          phoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED ||
          phoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.BYPASSED
      );
    }

    if (this.selectedChipValue.includes('chip1')) {
      let tempHomeInventoryList = tempAllInventoryList.filter(
        (tempAllInventoryList) => tempAllInventoryList.template === DeviceCardTemplate.home_device
      );
      tempHomeInventoryList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());

      let tempPhoneDiagnosticNotPassedList = tempPhoneInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.PASSED &&
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.BYPASSED
      );
      let tempPhoneDiagnosticPassedList = tempPhoneInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED ||
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.BYPASSED
      );
      tempPhoneDiagnosticNotPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());
      tempPhoneDiagnosticPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());

      let tempPhoneDiagnosticList = tempPhoneDiagnosticNotPassedList.concat(tempPhoneDiagnosticPassedList);

      this.inventoryList = tempPhoneDiagnosticList.concat(tempHomeInventoryList);
    } else if (this.selectedChipValue.includes('chip3') && this.isPhonePlanSupported) {
      let tempSmartphoneInventoryList = this.inventoryAllDevicesList.filter(
        (inventoryAllDevicesList) =>
          inventoryAllDevicesList.template === DeviceCardTemplate.phone_device || inventoryAllDevicesList.device.deviceType?.code === 'SMPH'
      );
      let tempPhoneDiagnosticNotPassedList = tempSmartphoneInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.PASSED &&
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.BYPASSED
      );
      let tempPhoneDiagnosticPassedList = tempSmartphoneInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED ||
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.BYPASSED
      );
      tempPhoneDiagnosticNotPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());
      tempPhoneDiagnosticPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());

      let tempPhoneDiagnosticList = tempPhoneDiagnosticNotPassedList.concat(tempPhoneDiagnosticPassedList);
      this.inventoryList = tempPhoneDiagnosticList;
    } else if (this.selectedChipValue.includes('chip4') && this.isPhonePlanSupported) {
      let tempTabletInventoryList = this.inventoryAllDevicesList.filter(
        (inventoryAllDevicesList) =>
          inventoryAllDevicesList.template === DeviceCardTemplate.cellular_device &&
          inventoryAllDevicesList.device.deviceType?.code === 'TABL'
      );
      let tempPhoneDiagnosticNotPassedList = tempTabletInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.PASSED &&
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.BYPASSED
      );
      let tempPhoneDiagnosticPassedList = tempTabletInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED ||
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.BYPASSED
      );
      tempPhoneDiagnosticNotPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());
      tempPhoneDiagnosticPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());

      let tempPhoneDiagnosticList = tempPhoneDiagnosticNotPassedList.concat(tempPhoneDiagnosticPassedList);
      this.inventoryList = tempPhoneDiagnosticList;
    } else if (this.selectedChipValue.includes('chip5') && this.isPhonePlanSupported) {
      let tempSmartwatchInventoryList = this.inventoryAllDevicesList.filter(
        (inventoryAllDevicesList) =>
          inventoryAllDevicesList.template === DeviceCardTemplate.cellular_device &&
          inventoryAllDevicesList.device.deviceType?.code === 'SMAR'
      );
      let tempPhoneDiagnosticNotPassedList = tempSmartwatchInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.PASSED &&
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() != DeviceCardDiagnosticTestStatus.BYPASSED
      );
      let tempPhoneDiagnosticPassedList = tempSmartwatchInventoryList.filter(
        (tempPhoneInventoryList) =>
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED ||
          tempPhoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.BYPASSED
      );
      tempPhoneDiagnosticNotPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());
      tempPhoneDiagnosticPassedList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());

      let tempPhoneDiagnosticList = tempPhoneDiagnosticNotPassedList.concat(tempPhoneDiagnosticPassedList);
      this.inventoryList = tempPhoneDiagnosticList;
    } else if (this.selectedChipValue.includes('chip2')) {
      let tempHomeInventoryList = this.inventoryAllDevicesList.filter(
        (inventoryAllDevicesList) =>
          inventoryAllDevicesList.template === DeviceCardTemplate.home_device &&
          inventoryAllDevicesList.device.deviceType?.code != 'SMPH' &&
          inventoryAllDevicesList.device.deviceType?.code != 'SMAR' &&
          inventoryAllDevicesList.device.deviceType?.code != 'TABL'
      );
      tempHomeInventoryList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());
      this.inventoryList = tempHomeInventoryList;
    }
  }

  public handleSortMostRecentInventoryList() {
    this.inventoryList.sort((a, b) => new Date(b.device.createdAt).getTime() - new Date(a.device.createdAt).getTime());
  }

  public handleSortInventoryListChange(e) {
    if (e.value === 0) {
      // sort by Most Relevant
      this.handleRelevantSortInventoryList();
    } else if (e.value === 1) {
      // sort by most Recent
      this.handleSortMostRecentInventoryList();
    } else if (e.value === 2) {
      // sort Alphabetically
      this.handleAlphabeticalSortInventoryList();
    }
  }

  async loadComponents() {
    this.isPhonePlanSupported = this.resourceService.getPortalSetting('Global_CTC_IsPhonePlanSupported').Value?.toLowerCase() == 'true';
    this.programCode = this.resourceService.getPortalSetting('Global_ProgramCode').Value;
    this.accessToken = this.pghOktaService.getAccessToken();

    this.sortFormGroup = new FormGroup({
      sortSelect: new FormControl(''),
    });

    this.sortFormGroup.get('sortSelect').setValue(0);

    const joined$ = combineLatest([this.loggedInUserSettings.$selectedContract, this.loggedInUserSettings.$userClaims]).pipe(
      filter(([a, b]) => a !== null && b !== null)
    );

    joined$.subscribe(([contract, userClaims]: [ISelectedContract, UserClaims]) => {
      this.selectedContract = contract;
      const isUserPrimary = this.analytics.isUserPrimary(contract, userClaims);
      this.userEmail = userClaims.email;
      this.userType = isUserPrimary ? 'Primary' : 'Secondary';
      this.usersOnContract = contract.members.length;

      this.isTechServicesChatEnabled =
        this.loggedInUserSettings.isFeatureEnabled(this.selectedContract.dealerId, CHATGROUP) &&
        this.loggedInUserSettings.isFeatureEnabled(this.selectedContract.dealerId, CHAT);

      this.hasClientSoldPolicy = !!this.selectedContract?.certificateNumberForClientSoldGadgetsPolicy;
      if (this.hasClientSoldPolicy) {
        this.loadGadgetDevices(this.selectedContract?.certificateNumberForClientSoldGadgetsPolicy, true);
      }
      if (!this.deviceViewType || this.deviceViewType == 'EPRISM') {
        this.loadEprismDevices();
      }
      if (!this.deviceViewType || this.deviceViewType == 'ELITA') {
        this.loadGadgetDevices(this.selectedContract?.certificateNumberForGadgetsPolicy, false);
        this.loadDiagnosticDevices();
      }
    });

    window.addEventListener('message', this.scrollToPosition);
    window.addEventListener('message', this.emitTagManagerEvent);
  }

  public mapInventoryList(devices: DeviceDto[], isDiagnosticList: boolean): IDeviceCardDetails[] {
    if (isDiagnosticList) {
      return devices
        .map<IDeviceCardDetails>((device) => ({
          actionLink: `${device.make ?? ''} ${device.model ?? ''}`.trim(),
          iconName:
            device?.deviceType?.code === 'TABL' || device?.deviceType?.code === 'SMAR'
              ? this.deviceTypeService.getDeviceTypeByCodeOrDefault(device.deviceType?.code).imageKey
              : '',
          title: device.nickName ?? '',
          id: device.id?.toString(),
          device: device,
          ariaLabel: this.resourceService.getPortalLabel('DeviceCard_ARIA_Label').Value,
          template:
            device?.deviceType?.code === 'TABL' || device?.deviceType?.code === 'SMAR'
              ? DeviceCardTemplate.cellular_device
              : DeviceCardTemplate.phone_device,
          diagnosticDeviceDetails: {
            isDeviceRegistered:
              device.diagnosticStatus == null ||
              device.diagnosticStatus?.toUpperCase() == DeviceCardDiagnosticTestStatus.PASSED ||
              device.diagnosticStatus?.toUpperCase() == DeviceCardDiagnosticTestStatus.BYPASSED,
            deviceTestStatus: device.diagnosticStatus
              ? DeviceCardDiagnosticTestStatus[device.diagnosticStatus?.toUpperCase()]
              : DeviceCardDiagnosticTestStatus.PASSED,
            lineNumber:
              device?.deviceType?.code === 'TABL' || device?.deviceType?.code === 'SMAR'
                ? null
                : this.utilityServce.getFormattedPhoneNumber(device.lineNumber),
          },
          sortOrder: this.getSortOrder(device.diagnosticStatus),
        }))
        .sort((a: IDeviceCardDetails, b: IDeviceCardDetails) => a.sortOrder - b.sortOrder);
    } else {
      return devices.map<IDeviceCardDetails>((device) => ({
        id: device.id?.toString(),
        title: device.nickName ?? '',
        template: DeviceCardTemplate.home_device,
        actionLink: `${device.make ?? ''} ${device.model ?? ''}`.trim(),
        iconName: this.deviceTypeService.getDeviceTypeByCodeOrDefault(device.deviceType?.code).imageKey,
        ariaLabel: this.resourceService.getPortalLabel('DeviceCard_ARIA_Label').Value,
        device: device,
      }));
    }
  }

  public loadDiagnosticDevices() {
    if (this.isEprismOnly) {
      // This is intentional as there will be new method for getting the Eprims only devices
      return;
    }
    if (this.isPhonePlanSupported && this.selectedContract.certificateNumberForPhonesPolicy) {
      this.deviceInventoryService
        .getInventoryInfo(this.selectedContract.certificateNumberForPhonesPolicy, this.programCode, this.selectedContract.dealerId)
        .pipe(
          tap((inventory) => (this.phoneInventoryInfo = inventory)),
          concatMap((inventory) => this.deviceInventoryService.getDevices(inventory?.id)))
        .subscribe({
          next: (phones) => {
            this.phoneDevices = phones;
            if (this.phoneInventoryList.length > 0) {
              let tempPhoneDiagnosticList = this.mapInventoryList(this.phoneDevices, true);
              this.phoneInventoryList = this.phoneInventoryList.concat(tempPhoneDiagnosticList);
            } else {
              this.phoneInventoryList = this.mapInventoryList(this.phoneDevices, true);
            }

            if (this.isSelectViewTemplate) {
              let tempPhoneDiagnosticNotPassedList = this.phoneInventoryList.filter(
                (phoneInventoryList) =>
                  phoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.PASSED ||
                  phoneInventoryList.device.diagnosticStatus?.toUpperCase() === DeviceCardDiagnosticTestStatus.BYPASSED
              );
              // for select view, to avoid duplicates, filtering out wifi-only devices (no imei) from current list as they will reside in the gadget list as well
              this.inventoryList = this.inventoryList.concat(tempPhoneDiagnosticNotPassedList.filter((item) => item.device.imei != null));
            } else {
              if (this.inventoryList.length > 0) {
                this.inventoryList = this.inventoryList.concat(
                  this.phoneInventoryList.filter((item) => item.device.inventoryId === this.phoneInventoryInfo?.id)
                );
              } else {
                this.inventoryList = this.inventoryList.concat(this.phoneInventoryList);
              }
            }

            this.inventoryAllDevicesList = this.inventoryList;
            if (this.homeDevicesLoaded) {
              this.loadDeviceTypeCount();
            }
            this.handleDefaultSortInventoryList();
            this.phoneDevicesLoaded = true;
          },
        });
    }
  }

  public loadGadgetDevices(policy: string, isClientSoldPolicy: boolean) {
    if (this.isEprismOnly) {
      // This is intentional as there will be new method for getting the Eprims only devices
      return;
    }
    this.deviceInventoryService.getInventoryInfo(policy, this.programCode, this.selectedContract.dealerId)
      .pipe(
        tap((inventory) =>
          isClientSoldPolicy ? (this.clientSoldDeviceInventoryInfo = inventory) : (this.deviceInventoryInfo = inventory)
        ),
        concatMap((inventory) => this.deviceInventoryService.getDevices(inventory?.id))
      )
      .subscribe({
        next: (devices) => {
          this.homeDevices = this.homeDevices.concat(devices);
          let diagnosticDevices = devices.filter((item) => item.diagnosticStatus != null);
          let nonDiagnosticDevices = devices.filter((item) => item.diagnosticStatus == null);

          if (diagnosticDevices.length > 0) {
            if (!this.phoneDevicesLoaded) {
              this.phoneInventoryList = this.mapInventoryList(diagnosticDevices, true);
            } else {
              let tempPhoneDiagnosticList = this.mapInventoryList(diagnosticDevices, true);
              this.phoneInventoryList = this.phoneInventoryList.concat(tempPhoneDiagnosticList);
            }
          }
          if (nonDiagnosticDevices.length > 0) {
            this.deviceInventoryList = this.deviceInventoryList.concat(this.mapInventoryList(nonDiagnosticDevices, false));
            if (this.phoneDevicesLoaded) {
              this.inventoryList = this.deviceInventoryList.concat(this.phoneInventoryList);
            } else {
              this.inventoryList = this.hasClientSoldPolicy
                ? this.deviceInventoryList
                : this.inventoryList.concat(this.deviceInventoryList);
            }
            this.inventoryAllDevicesList = this.inventoryList;
            this.handleDefaultSortInventoryList();
          } else {
            this.inventoryList = this.inventoryList.concat(this.phoneInventoryList);
            this.inventoryAllDevicesList = this.inventoryList;
          }
          this.loadDeviceTypeCount();
          this.homeDevicesLoaded = true;
        },
      });
  }

  public loadEprismDevices() {
    if (this.hasP360MobilePolicy) {
      const eprismDevices = this.deviceInventoryService.getEprismDevices();
      this.eprismDeviceInventoryList = this.mapInventoryList(eprismDevices, false);
      //this.inventoryList = this.inventoryList.concat(this.mapInventoryList(eprismDevices, false));
      //this.inventoryAllDevicesList = this.inventoryList;
     // this.loadDeviceTypeCount();
     // this.homeDevicesLoaded = this.isEprismOnly || this.deviceViewType == 'EPRISM';
    }
  }

  public loadDeviceTypeCount() {
    this.phonesCount = 0;
    this.homeCount = 0;
    this.watchCount = 0;
    this.tabletCount = 0;
    this.inventoryAllDevicesList.forEach((device) => {
      if (this.isSelectViewTemplate && device.device != null && device.device.deviceType != null) {
        if (
          device.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.PASSED ||
          device.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.BYPASSED
        ) {
          if (device.device.deviceType.code === 'SMPH') {
            this.phonesCount++;
          } else if (device.device.deviceType.code === 'TABL') {
            this.tabletCount++;
          } else if (device.device.deviceType.code === 'SMAR') {
            this.watchCount++;
          }
        } else if (device.template === DeviceCardTemplate.home_device) {
          this.homeCount++;
        }
      } else {
        if (device.device != null && device.device.deviceType != null) {
          if (device.device.deviceType.code === 'SMPH') {
            this.phonesCount++;
          } else if (device.device.deviceType.code === 'TABL') {
            this.tabletCount++;
          } else if (device.device.deviceType.code === 'SMAR') {
            this.watchCount++;
          } else if (device.template === DeviceCardTemplate.home_device) {
            this.homeCount++;
          }
        } else if (device.template === DeviceCardTemplate.phone_device) {
          this.phonesCount++;
        } else if (device.template === DeviceCardTemplate.home_device) {
          this.homeCount++;
        }
      }
    });

    if (this.isSelectViewTemplate) {
      this.selectViewTotalCount = this.homeCount + this.phonesCount + this.tabletCount + this.watchCount;
    }

    if (this.phonesCount > 0) {
      this.noSmartPhoneDevicesFound = false;
    } else {
      this.noSmartPhoneDevicesFound = true;
    }
    if (this.homeCount > 0) {
      this.noHomeDevicesFound = false;
    } else {
      this.noHomeDevicesFound = true;
    }
    if (this.watchCount > 0) {
      this.noSmartWatchDevicesFound = false;
    } else {
      this.noSmartWatchDevicesFound = true;
    }
    if (this.tabletCount > 0) {
      this.noTabletDevicesFound = false;
    } else {
      this.noTabletDevicesFound = true;
    }

    if (this.inventoryAllDevicesList.length > 0) {
      this.noDevicesFound = false;
    } else {
      this.noDevicesFound = true;
    }

    this.isComponentLoaded = true;
  }

  public scrollToPosition(event: any) {
    if (event.data.action === 'deviceFormLoaded') {
      const element = document.querySelector('.device-inventory-container');
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  public deviceSelected(event: EssDeviceDto) {
    const pghDevice = this.deviceAutoCompleteMfeService.buildPghUserDeviceFromEssDevice(event);
    this.selectedDeviceService.setSelectedDevice(pghDevice);
    this.router.navigate(['/home-device-details']);
  }

  public handleEditDevice(event) {
    if (event.template === DeviceCardTemplate.home_device) {
      this.handleEditHomeDevice(event);
    } else if (event.template === DeviceCardTemplate.phone_device || event.template === DeviceCardTemplate.cellular_device) {
      this.handleEditPhoneDevice(event);
    }
  }

  public handleAddDevice(event) {

    if(this.isSPOEEnabled){
      this.handleAddSearchDeviceAction.emit('Handle Add Device Action');
    }
    else
    {
      if (event.template === DeviceCardTemplate.home_device) {
        this.handleAddHomeDeviceManually(event);
      } else if (event.template === DeviceCardTemplate.phone_device || event.template === DeviceCardTemplate.cellular_device) {
        this.handleAddPhoneDevice(event);
      }
    }
  }

  public handleEprismDeviceClaims(device){

    // construct string to encrypt

    let eprismContracts = this.storageService.getLocal<any[]>('EprismContracts');
    let oktaUserProfile = this.storageService.getLocal<OktaUserProfile>('okta-user-profile');

    const eContract = eprismContracts.find(x => x.policyIdentifier.mobileNumber == oktaUserProfile.primaryPhone);

    if(eContract){
      let customerIdentifier = device.phoneNumber;
      let zipCode = eContract.policyHolderInfo.zipCode;
      let email = eContract.policyHolderInfo.email;

      const currentDate = new Date();
      let utcIsoString = currentDate.toISOString();

      let stringToEncrypt: string = "";

      stringToEncrypt += "newStandardTimestamp=" + utcIsoString + "|";
      stringToEncrypt += "customerIdentifier=" + customerIdentifier + "|";
      stringToEncrypt += "identifierType=MobileNumber" + "|";
      stringToEncrypt += "customerPath=FileClaim" + "|";
      stringToEncrypt += "zip=" + zipCode + "|";
      stringToEncrypt += "email=" + email + "|";
      stringToEncrypt += "carrierCode=7|myAccount=true";

      this.cryptoService.mwcEncryptData(stringToEncrypt).subscribe(
        res => {
          let mwcUrl = this.resourceService.getPortalSetting("URL_External_MWC_Claims").Value;
          if(mwcUrl)
          {
            let url = mwcUrl + '?token=' + res.encryptedData;
            window.open(url, '_self');
          }

        }
      );
    }
  }

  public handleSelectDevice(event) {
    const selectedDevice = event.device;

    if(selectedDevice.deviceSource && selectedDevice.deviceSource === 'EPRISM'){
      this.handleEprismDeviceClaims(selectedDevice);
    }
    else{
      const deviceBase: PghUserDeviceBase = {
        deviceTypeCode: selectedDevice.deviceType?.code,
        deviceTypeName: selectedDevice.deviceType?.name,
        hasReceipt: selectedDevice.hasReceipt,
        modelIdentifier: selectedDevice.modelIdentifier,
        deviceId: selectedDevice.id,
        inventoryId: selectedDevice.inventoryId,
        nickName: selectedDevice.nickName,
        make: selectedDevice.make,
        model: selectedDevice.model,
        displayName: selectedDevice.description,
        serialNumber: selectedDevice.serialNumber,
        purchaseDate: selectedDevice.purchaseDate,
        purchasePrice: selectedDevice.purchasePrice,
        deviceSource: selectedDevice.deviceSource,
        phoneNumber: selectedDevice.phoneNumber,
      };

      if (selectedDevice?.deviceType?.coverages != null) {
        deviceBase.coverage = {
          hasAccidentalDamage: selectedDevice?.deviceType?.coverages?.hasAccidentalDamage,
          hasMechanicalDamage: selectedDevice?.deviceType?.coverages?.hasMechanicalDamage,
          hasLoss: selectedDevice?.deviceType?.coverages?.hasLoss,
          hasTheft: selectedDevice?.deviceType?.coverages?.hasTheft,
        };
      }
      this.selectedDeviceService.setSelectedDevice(deviceBase);
      this.router.navigate(['/claims-support']);
    }
  }

  public handleDeleteDevice(event) {
    let isDiagnosticDevice: boolean = false;
    if (event.device.diagnosticStatus != null) {
      isDiagnosticDevice = true;
    }

    if (!isDiagnosticDevice) {
      this.handleDeleteHomeDevice(event);
    } else {
      this.handleDeleteCellularEnabledDevice(event);
    }
  }

  public handleViewDevice(event) {
    if (event.template === DeviceCardTemplate.home_device) {
      this.handleHomeDeviceSelected(event);
    } else if (event.template === DeviceCardTemplate.phone_device || event.template === DeviceCardTemplate.cellular_device) {
      this.handleViewPhoneDevice(event);
    }
  }

  // #region HOME-DEVICE-EVENTS

  public handleEditHomeDevice(e): void {
    let deviceDetails: IDeviceCardDetails = e;
    console.log('Handle Edit Action for ' + deviceDetails.title);
  }

  public handleHomeDeviceSelected(event) {
    const device: DeviceDto = event.device;
    let deviceBase: PghUserDeviceBase = {
      deviceId: device.id,
      inventoryId: device.inventoryId,
      nickName: device.nickName,
      make: device.make,
      model: device.model,
      modelIdentifier: device.modelIdentifier,
      hasReceipt: device.hasReceipt,
      coverage: device.deviceType?.coverages,
      deviceTypeCode: device.deviceType?.code,
      deviceTypeName: device.deviceType?.name,
      serialNumber: device.serialNumber,
      imei: device.imei,
      purchaseDate: device.purchaseDate,
      purchasePrice: device.purchasePrice,
      deviceSource: device.deviceSource,
      phoneNumber: device.phoneNumber
    };

    if (device.deviceSource == 'EPRISM') {
      this.deviceInventoryService.getEprismDeviceTypes(device.phoneNumber).subscribe(deductible => {
        deviceBase.coverage = deductible.coverages;
        deviceBase.deductibleAmounts = deductible.deductibleAmounts;
        this.selectedDeviceService.setSelectedDevice(deviceBase);
        this.router.navigate(['/home-device-details']);
      });
    } else {
      this.selectedDeviceService.setSelectedDevice(deviceBase);
      this.router.navigate(['/home-device-details']);
    }
  }

  public handleAddHomeDeviceManually(event?: any) {
    let deviceDetails = event?.device;
    const manualDeviceData: PghUserDeviceBase = {
      inventoryId: deviceDetails?.inventoryId,
      nickName: deviceDetails?.nickName,
      make: deviceDetails?.make,
      model: deviceDetails?.model,
      modelIdentifier: deviceDetails?.modelIdentifier,
      deviceTypeCode: deviceDetails?.deviceType.code,
      deviceSource: deviceDetails?.deviceSource
    };

    //validate device to add is valid
    if (this.homeDeviceDetailsIsValid(manualDeviceData)) {
      this.addHomeDeviceManually(manualDeviceData);
    } else {
      this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceInventory_ManualAdd_Missing_Required_Fields'));
      console.error('Device details to add missing required fields');
    }
  }

  public handleDeleteHomeDevice(event: any) {
    const device: DeviceDto = event.device;
    const deviceToRemove: PghUserDeviceBase = {
      deviceId: device.id,
      inventoryId: device.inventoryId,
      nickName: device.nickName,
      make: device.make,
      model: device.model,
      modelIdentifier: device.modelIdentifier,
      hasReceipt: device.hasReceipt,
      coverage: device.deviceType?.coverages,
      deviceTypeCode: device.deviceType?.code,
      deviceTypeName: device.deviceType?.name,
    };

    if (deviceToRemove?.deviceId == null) {
      console.error(`Didn't find the device to remove.`);
      return;
    }

    let deviceLabel: string = ((deviceToRemove?.make ?? '') + ' ' + (deviceToRemove?.model ?? '')).trim();
    const contextData = { Device: deviceLabel };
    let dialogData: ConfirmationDialogData;
    //when deleting a device that has passed diagnostics, need to alert the user that they would need to run diagnostics on this device again in order
    //to have coverage on the device
    if (device?.diagnosticStatus === DeviceCardDiagnosticTestStatus.PASSED) {
      dialogData = {
        title: 'DeviceDetails_RemovePassedDiagDevice_Modal_Title',
        message: 'DeviceDetails_RemovePassedDiagDevice_Modal_Message',
        cancelButtonText: 'Global_Button_Cancel',
        confirmButtonText: 'DeviceDetails_RemovePhone_Modal_Submit_Button_Label',
        contextData: contextData,
      };
    } else {
      dialogData = {
        title: 'DeviceDetails_RemoveDevice_Modal_Title',
        message: 'DeviceDetails_RemoveDevice_Modal_Message',
        cancelButtonText: 'Global_Button_Cancel',
        confirmButtonText: 'DeviceDetails_RemovePhone_Modal_Submit_Button_Label',
        contextData: contextData,
      };
    }

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData,
    });
    this.subscriptions.push(
      confirmationDialog.afterClosed().subscribe({
        next: (result) => {
          if (result.toString() === 'true') {
            let isDiagnosticDevice: boolean = false;
            if (event.device.diagnosticStatus != null) {
              isDiagnosticDevice = true;
            }
            this.removeDevice(deviceToRemove, isDiagnosticDevice);
          }
        },
      })
    );
  }

  private emitTagManagerEvent = (event: any) => {
    if (event.data.action === 'emitGTMEvent') {
      const gtagEvent = event.data.message;
      if (gtagEvent) {
        this.analytics.emitGTMEvent(gtagEvent);
      }
    }
  };

  private homeDeviceDetailsIsValid(deviceToAdd?: PghUserDeviceBase) {
    if (deviceToAdd == null) {
      return false;
    }
    if (deviceToAdd?.deviceTypeCode == null || deviceToAdd?.deviceTypeCode.length <= 0) {
      return false;
    }
    if (deviceToAdd?.model == null || deviceToAdd?.model.length <= 0) {
      return false;
    }
    if (deviceToAdd?.make == null || deviceToAdd?.make.length <= 0) {
      return false;
    }

    return true;
  }

  private addHomeDeviceManually(deviceToAdd: PghUserDeviceBase) {
    const createDeviceBody = this.deviceInventoryService.buildCreateDeviceBodyDtoFromPghUserDeviceBase(
      deviceToAdd,
      deviceToAdd.inventoryId,
      'USER'
    );
    this.deviceInventoryService.createDevice(createDeviceBody).subscribe({
      next: (value) => {
        if (value) {
          deviceToAdd.deviceId = value.id;
          this.selectedDeviceService.updateAllDevices(deviceToAdd);
          this.snackbarService.showSimpleMessage(
            this.resourceService.getPortaLabelValue('DeviceInventory_ManualAdd_Missing_Required_Fields')
          );
          // Emit device inventory add complete event
          this.analytics.emitDeviceInventoryEvent(
            GTMEvents.DeviceInventoryAddComplete,
            GTMDeviceFlow.AddDevice,
            deviceToAdd.deviceTypeName,
            deviceToAdd.make,
            deviceToAdd.model
          );
          setTimeout(() => {
            this.loadComponents();

            //update the user's inventory device count in the UserInfo db
            const updateUserInfoDevicesCountDto: UpdateUserInfoDevicesCountDto = {
              EmailAddress: this.userEmail,
              DeviceCount: this.selectedDeviceService.getAllDevices().length,
            };
            this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({
              error: (err) => {
                throw err;
              },
            });
          }, 100);
        } else {
          this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceInventory_ManualAdd_Error_Message'));
          console.error('Device not added: ' + JSON.stringify(deviceToAdd));
          // Emit device inventory add fail event
          this.analytics.emitDeviceInventoryEvent(
            GTMEvents.DeviceInventoryAddFail,
            GTMDeviceFlow.AddDevice,
            deviceToAdd.deviceTypeName,
            deviceToAdd.make,
            deviceToAdd.model
          );
        }
      },
      error: (err) => {
        this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue('DeviceInventory_ManualAdd_Error_Message'));
        console.error('Device not added: ' + JSON.stringify(deviceToAdd));
        // Emit device inventory add fail event
        this.analytics.emitDeviceInventoryEvent(
          GTMEvents.DeviceInventoryAddFail,
          GTMDeviceFlow.AddDevice,
          deviceToAdd.deviceTypeName,
          deviceToAdd.make,
          deviceToAdd.model
        );
        throw err;
      },
    });
  }

  private removeDevice(deviceBase: PghUserDeviceBase, isDiagnosticDevice: boolean) {
    if (this.isEprismOnly) {
      return;
    }
    const deviceToUpdate: UpdateDeviceBodyDto = {
      id: deviceBase.deviceId,
      inventoryId: deviceBase.inventoryId,
      nickName: crypto.randomUUID(),
      imei: '',
    };

    let isRevokeInv: boolean = false;
    if (!isDiagnosticDevice) {
      isRevokeInv = false;
    } else {
      isRevokeInv = true;
    }

    if (isRevokeInv) {
      combineLatest([
        this.deviceInventoryService.updateDevice(deviceToUpdate),
        this.accountService.revokeInvitation(Number(deviceToUpdate.id)),
      ])
        .pipe(
          filter(([device, revokeInv]) => device && revokeInv == true),
          concatMap((updatedDevice) => this.deviceInventoryService.deleteDevice(deviceBase.deviceId, deviceBase.inventoryId))
        )
        .subscribe({
          next: (result) => {
            if (result) {
              this.removeDeviceFromLists(deviceBase.deviceId);
              this.selectedDeviceService.removeDeviceFromAllDevices(deviceBase);
              const cacheKey = `${this.deviceInventoryService.GraphQLgetDevices}${deviceBase.inventoryId}`;

              // if wifi-only diagnostic device, set to home device local storage instead of phones
              /*if(deviceBase.imei != null){
              sessionStorage.setItem(cacheKey, JSON.stringify(this.phoneDevices));
            }else{
              sessionStorage.setItem(cacheKey, JSON.stringify(this.homeDevices));
            }*/

              this.snackbarService.showSimpleMessage(
                this.resourceService.getPortalLabel('DeviceInventory_Snackbar_Successful_Remove').Value
              );
              this.inventoryAllDevicesList = this.deviceInventoryList.concat(this.phoneInventoryList);
              this.loadDeviceTypeCount();
              this.updateUserInfoDevicesCount();

              this.analytics.emitDeviceInventoryEvent(
                GTMEvents.DeviceInventoryAddComplete,
                GTMDeviceFlow.DeleteDevice,
                deviceBase.deviceTypeName,
                deviceBase.make,
                deviceBase.model
              );
            }
          },
          error: (error) => {
            this.analytics.emitDeviceInventoryEvent(
              GTMEvents.DeviceInventoryAddFail,
              GTMDeviceFlow.DeleteDevice,
              deviceBase.deviceTypeName,
              deviceBase.make,
              deviceBase.model
            );
            throw error;
          },
        });
    } else {
      this.deviceInventoryService.updateDevice(deviceToUpdate)
        .pipe(concatMap((updatedDevice) => this.deviceInventoryService.deleteDevice(deviceBase.deviceId, deviceBase.inventoryId)))
        .subscribe({
          next: () => {
            this.removeDeviceFromLists(deviceBase.deviceId);
            this.selectedDeviceService.removeDeviceFromAllDevices(deviceBase);
            const cacheKey = `${this.deviceInventoryService.GraphQLgetDevices}${deviceBase.inventoryId}`;
            //sessionStorage.setItem(cacheKey, JSON.stringify(this.homeDevices));
            this.snackbarService.showSimpleMessage(this.resourceService.getPortalLabel('DeviceInventory_Snackbar_Successful_Remove').Value);
            this.loadDeviceTypeCount();
            this.updateUserInfoDevicesCount();
            this.analytics.emitDeviceInventoryEvent(
              GTMEvents.DeviceInventoryAddComplete,
              GTMDeviceFlow.DeleteDevice,
              deviceBase.deviceTypeName,
              deviceBase.make,
              deviceBase.model
            );
          },
          error: (error) => {
            this.analytics.emitDeviceInventoryEvent(
              GTMEvents.DeviceInventoryAddFail,
              GTMDeviceFlow.DeleteDevice,
              deviceBase.deviceTypeName,
              deviceBase.make,
              deviceBase.model
            );
            throw error;
          },
        });
    }
  }

  public removeDeviceFromLists(deviceId: number) {
    _remove(this.deviceInventoryList, { id: deviceId.toString() });
    if (this.inventoryList) {
      _remove(this.inventoryList ?? [], { id: deviceId.toString() });
      _remove(this.inventoryAllDevicesList ?? [], { id: deviceId.toString() });

      if (this.phoneInventoryList) {
        _remove(this.phoneInventoryList ?? [], { id: deviceId.toString() });
      }
    }
    if (this.homeDevices) {
      _remove(this.homeDevices, { id: deviceId });
    }
    if (this.phoneDevices) {
      _remove(this.phoneDevices, { id: deviceId });
    }
  }

  public updateUserInfoDevicesCount() {
    //update the user's inventory device count in the UserInfo db
    const updateUserInfoDevicesCountDto: UpdateUserInfoDevicesCountDto = {
      EmailAddress: this.userEmail,
      DeviceCount: this.selectedDeviceService.getAllDevices().length,
    };
    this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({
      error: (err) => {
        throw err;
      },
    });
  }

  // #endregion

  // #region PHONE-DEVICE-EVENTS

  public validatePhone(control: UntypedFormControl) {
    if (control?.value != null) {
      if (!this.utilityServce.isValidPhoneFormat(control.value)) {
        return { invalid: true };
      }
    }
  }

  public changeSelected(e) {
    //reset flags
    this.showNoDevicesSection = false;
    this.showNoHomeDevicesSection = false;
    this.showNoPhoneDevicesSection = false;
    this.showNoTabletDevicesSection = false;
    this.showNoWatchDevicesSection = false;

    this.selectedChipValue = e.source.id;

    let filteredList: IDeviceCardDetails[] = [];

    if (this.selectedChipValue.includes('chip3')) {
      // Smartphones
      filteredList = this.inventoryAllDevicesList.filter(
        (inventoryAllDevicesList) =>
          inventoryAllDevicesList.template === DeviceCardTemplate.phone_device || inventoryAllDevicesList.device.deviceType?.code === 'SMPH'
      );
      this.showNoPhoneDevicesSection = true;
    } else if (this.selectedChipValue.includes('chip2')) {
      // Home devices
      filteredList = this.inventoryAllDevicesList.filter(
        (inventoryAllDevicesList) =>
          inventoryAllDevicesList.template === DeviceCardTemplate.home_device &&
          inventoryAllDevicesList.device.deviceType?.code != 'SMPH' &&
          inventoryAllDevicesList.device.deviceType?.code != 'SMAR' &&
          inventoryAllDevicesList.device.deviceType?.code != 'TABL'
      );
      this.showNoHomeDevicesSection = true;
    } else if (this.selectedChipValue.includes('chip1')) {
      // All devices
      filteredList = this.inventoryAllDevicesList;
      this.showNoDevicesSection = true;
    } else if (this.selectedChipValue.includes('chip5')) {
      // Smartwatches
      filteredList = this.inventoryAllDevicesList.filter((xx) => xx.device.deviceType?.code === 'SMAR');
      this.showNoWatchDevicesSection = true;
    } else if (this.selectedChipValue.includes('chip4')) {
      // Tablets
      filteredList = this.inventoryAllDevicesList.filter((xx) => xx.device.deviceType?.code === 'TABL');
      this.showNoTabletDevicesSection = true;
    }

    this.inventoryList = filteredList;

    this.handleDefaultSortInventoryList();
  }

  public handleDeleteCellularEnabledDevice(e): void {
    const deviceToRemove: IDeviceCardDetails = e;
    let deviceLabel: string = ((deviceToRemove?.device.make ?? '') + ' ' + (deviceToRemove?.device.model ?? '')).trim();
    let phoneNumber: string = deviceToRemove?.diagnosticDeviceDetails?.lineNumber ?? '';
    const contextData = e.template == DeviceCardTemplate.phone_device ? { PhoneNumber: phoneNumber } : { Device: deviceLabel };

    let dialogData: ConfirmationDialogData;
    //when deleting a device that has passed diagnostics, need to check if it's the last PASSED device in the mobile inventory because
    //need to alert the user that it may effect their coverage plan
    if (this.isLastInsuredCellularDevice(deviceToRemove)) {
      dialogData = {
        title: 'DeviceDetails_RemoveLastPassedDiagDevice_Modal_Title',
        message: 'DeviceDetails_RemoveLastPassedDiagDevice_Modal_Message',
        cancelButtonText: 'Global_Button_Cancel',
        confirmButtonText: 'DeviceDetails_RemovePhone_Modal_Submit_Button_Label',
        isPhoneDeviceView: false,
        phoneNumber: deviceToRemove.diagnosticDeviceDetails?.lineNumber,
        contextData: contextData,
      };
    }
    //when deleting a device that has passed diagnostics, need to alert the user that they would need to run diagnostics on this device again in order
    //to have coverage on the device
    else if (
      deviceToRemove?.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.PASSED ||
      deviceToRemove?.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.BYPASSED
    ) {
      dialogData = {
        title: 'DeviceDetails_RemovePassedDiagDevice_Modal_Title',
        message: 'DeviceDetails_RemovePassedDiagDevice_Modal_Message',
        cancelButtonText: 'Global_Button_Cancel',
        confirmButtonText: 'DeviceDetails_RemovePhone_Modal_Submit_Button_Label',
        isPhoneDeviceView: false,
        phoneNumber: deviceToRemove.diagnosticDeviceDetails?.lineNumber,
        contextData: contextData,
      };
    }
    //all other scenarios have a simple confirmation message
    else {
      dialogData = {
        title:
          e.template == DeviceCardTemplate.phone_device
            ? 'DeviceDetails_RemovePhone_Modal_Title'
            : 'DeviceDetails_RemoveDevice_Modal_Title',
        message:
          e.template == DeviceCardTemplate.phone_device
            ? 'DeviceDetails_RemovePhone_Modal_Message'
            : 'DeviceDetails_RemoveDevice_Modal_Message',
        cancelButtonText: 'Global_Button_Cancel',
        confirmButtonText: 'DeviceDetails_RemovePhone_Modal_Submit_Button_Label',
        isPhoneDeviceView: e.template == DeviceCardTemplate.phone_device ? true : false,
        phoneNumber: deviceToRemove.diagnosticDeviceDetails?.lineNumber,
        contextData: contextData,
      };
    }

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData,
    });
    this.subscriptions.push(
      confirmationDialog.afterClosed().subscribe({
        next: (result) => {
          if (result.toString() === 'true') {
            const device: DeviceDto = deviceToRemove.device;
            const diagnosticDeviceToRemove: PghUserDeviceBase = {
              deviceId: device.id,
              inventoryId: device.inventoryId,
              nickName: device.nickName,
              make: device.make,
              model: device.model,
              modelIdentifier: device.modelIdentifier,
              hasReceipt: device.hasReceipt,
              coverage: device.deviceType?.coverages,
              deviceTypeCode: device.deviceType?.code,
              deviceTypeName: device.deviceType?.name,
              imei: device.imei,
              serialNumber: device.serialNumber,
            };
            if (diagnosticDeviceToRemove?.deviceId == null) {
              console.error(`Didn't find the device to remove.`);
              return;
            }
            let isDiagnosticDevice: boolean = false;
            if (e.device.diagnosticStatus != null) {
              isDiagnosticDevice = true;
            }
            this.removeDevice(diagnosticDeviceToRemove, isDiagnosticDevice);
          }
        },
      })
    );
  }

  public handleResumeTest(deviceDetails: IDeviceCardDetails): void {
    this.accountService.registerInvitationToDevice(deviceDetails.device.id, deviceDetails.device.inventoryId, false).subscribe((res) => {
      let data: any[] = [];
      data.push([]);
      data[0].res = res;
      let deviceInvitationCode = data[0].res.invitationCode;
      const dialogConfig = new MatDialogConfig();
      dialogConfig.ariaLabel = this.resourceService.getPortalLabel('Global_ResumeDiagnostic_ARIA_Label').Value;
      dialogConfig.data = {
        deviceTypeCode: deviceDetails?.device?.deviceType?.code,
        imei: deviceDetails.device?.imei,
        invitationCode: deviceInvitationCode,
      };

      const dialogRef = this.dialog.open(ResumeDiagnosticTestModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((res) => {});
    });
  }

  public handleEditPhoneDevice(e): void {
    let deviceDetails: IDeviceCardDetails = e;
    console.log('Handle Edit Action for ' + deviceDetails.title);
  }

  public handleAddPhoneDevice(e): void {
    let addDeviceMessage: string = e;
    console.log(addDeviceMessage);
  }

  public handleViewPhoneDevice(e): void {
    let deviceDetails: IDeviceCardDetails = e;
    if (
      deviceDetails.diagnosticDeviceDetails.viewAction === this.resourceService.getPortalLabel('DeviceCard_Action_ResendInvite_Label').Value
    ) {
      if (deviceDetails?.diagnosticDeviceDetails?.lineNumber) {
        this.accountService
          .registerInvitationToDevice(
            deviceDetails?.device?.id,
            deviceDetails?.device?.inventoryId,
            true,
            this.utilityServce.getPhoneNumberForTwilio(deviceDetails?.diagnosticDeviceDetails?.lineNumber)
          )
          .subscribe((res) => {
            this.snackbarService.showSimpleMessage(this.resourceService.getPortalLabel('DeviceInventory_Invite_Sent').Value);
          });
      }
    } else if (
      deviceDetails.diagnosticDeviceDetails.viewAction ===
      this.resourceService.getPortalLabel('DeviceCard_Action_ViewTestResults_Label').Value
    ) {
      this.setSelectedPhone(deviceDetails);
      this.router.navigate(['home-device-details'], { queryParams: { viewTestResults: '1' } });
    } else if (
      deviceDetails.diagnosticDeviceDetails.viewAction === this.resourceService.getPortalLabel('DeviceCard_Action_ViewDetails_Label').Value
    ) {
      this.setSelectedPhone(deviceDetails);
      this.router.navigate(['home-device-details']);
    } else if (
      deviceDetails.diagnosticDeviceDetails.viewAction === this.resourceService.getPortalLabel('DeviceCard_Action_RescanQRCode_Label').Value
    ) {
      this.handleResumeTest(deviceDetails);
    }
  }

  public setSelectedPhone(deviceDetails: IDeviceCardDetails) {
    const device: PghUserDeviceBase = {
      deviceId: deviceDetails.device.id,
      inventoryId: deviceDetails.device.inventoryId,
      coverage: deviceDetails.device.deviceType?.coverages,
      deviceTypeCode: deviceDetails.device.deviceType?.code,
      deviceTypeName: deviceDetails.device.deviceType?.name,
      hasReceipt: deviceDetails.device.hasReceipt,
      modelIdentifier: deviceDetails.device.modelIdentifier,
      nickName: deviceDetails.device.nickName,
      make: deviceDetails.device.make,
      model: deviceDetails.device.model,
      imei: deviceDetails.device.imei,
      serialNumber: deviceDetails.device.serialNumber,
      lineNumber: this.utilityServce.getFormattedPhoneNumber(deviceDetails.device.lineNumber),
      deviceSource: deviceDetails.device.deviceSource,
      phoneNumber: deviceDetails.device.phoneNumber,
    };
    this.selectedDeviceService.setSelectedDevice(device);
  }

  private isLastInsuredCellularDevice(deviceToRemove: IDeviceCardDetails): boolean {
    if (
      (deviceToRemove?.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.PASSED ||
        deviceToRemove?.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.BYPASSED) &&
      deviceToRemove?.device?.deviceType?.coverages?.hasTheft
    ) {
      let count = this.phoneInventoryList.filter(
        (x) =>
          x.device?.deviceType?.coverages?.hasTheft &&
          (x.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.PASSED ||
            x.diagnosticDeviceDetails?.deviceTestStatus === DeviceCardDiagnosticTestStatus.BYPASSED)
      ).length;
      return count == 1;
    } else return false;
  }

  public noDevice(event?: any) {
    const formFieldsArray = this.resourceService.getViewLabel('DeviceDetails_Modal_NoDevice_FormFields_List');
    const dialogData: DeviceDetailsDialogData = {
      title: '',
      message: '',
      cancelButtonText: '',
      confirmButtonText: '',
      inventoryId: this.deviceInventoryInfo?.id,
      clientSoldInventoryId: this.clientSoldDeviceInventoryInfo?.id,
      devices: this.homeDevices,
      phoneInventoryId: this.phoneInventoryInfo?.id,
      phoneDevices: this.phoneDevices,
      formFields: formFieldsArray.split('|'),
      selectedDevice: null,
      contractStartDate: this.selectedContract?.startDate ?? new Date(),
    };

    const deviceDetailsDialog = this.dialog.open<DeviceDetailsDialogComponent, DeviceDetailsDialogData, boolean>(
      DeviceDetailsDialogComponent,
      {
        data: dialogData,
        disableClose: true,
        panelClass: 'device-details-dialog-container',
      }
    );

    this.subscriptions.push(
      deviceDetailsDialog.afterClosed().subscribe({
        next: (result) => {
          if (result === true) {
            this.selectedDeviceService.setSelectedDevice(deviceDetailsDialog.componentInstance.deviceDto);
            this.router.navigate(['/home-device-details', { noDevice: true }]);
          }
        },
      })
    );
  }

  // #endregion

  getSortOrder(diagnosticStatus: string): number {
    if (diagnosticStatus == DeviceCardDiagnosticTestStatus.BYPASSED) return 4;
    if (diagnosticStatus == DeviceCardDiagnosticTestStatus.PASSED) return 3;
    if (diagnosticStatus == DeviceCardDiagnosticTestStatus.PENDING) return 1;
    if (diagnosticStatus == DeviceCardDiagnosticTestStatus.FAILED) return 2;
    return 5;
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.scrollToPosition);
    window.removeEventListener('message', this.emitTagManagerEvent);
  }
}
